import { checkboxClasses, Components, Theme } from "@mui/material";

export const MuiCheckbox: Components<Omit<Theme, "MuiCheckbox">>["MuiCheckbox"] = {
  styleOverrides: {
    root: ({ theme: { palette } }) => ({
      color: palette.common.black,

      [`&.${checkboxClasses.checked}`]: {
        color: palette.common.black,
      },

      [`&.${checkboxClasses.disabled}`]: {
        color: palette.grey[400],
      },
    }),
  },
};
